<template>
  <div class="container">
    <nav-top Title="升级VIP"></nav-top>
    <div class="user">
      <div class="userInfo">
        <div> <img src="@/assets/head_img.jpg" alt=""></div>
        <div>
          <p>{{ truncatedUserId }}</p>
          <p v-if="this.user.svip.type>0 && this.user.svip.status!=1">会员到期时间: {{user.svip.expire}}</p>
          <p v-else>您的会员已过期</p>
        </div>
      </div>
      <div class="vipSign">
        <img v-if="this.user.svip.type>0 && this.user.svip.status!=1" src="@/assets/svip_month.png" alt="">
        <img v-else src="@/assets/vip_none.png" alt="">
      </div>
    </div>
    <van-notice-bar
        left-icon="volume-o"
        text="请购买网易一卡通卡密进行充值。"
    />
    <div>
      <swiper
          ref="swiper"
          :loop="true"
          :modules="modules"
          :slides-per-view="1.2"
          :space-between="8"
          :initial-slide="tabsIndex"
          @slideChange="onchange"
          class="vipSwiper"
      >
        <swiper-slide v-for="data in upgradeData" :key="data">
          <div class="swiperPackage swiperForth">
            <div style="padding: 2vw">
              <div class="package_title">{{data.title}}</div>
              <div class="package_trc">{{data.trc}}</div>
              <div class="package_originalPrice">{{data.originalPrice}}</div>
              <div class="package_price">{{data.cny}} ￥</div>
            </div>
            <div>
              <img :src=requireImage(data.src) :alt=data.src>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="tabs">
        <div class="tabsTitle">会员权益</div>
        <div :class="{'active-tab': tabsIndex === index}" v-for="(data, index) in upgradeData" :key="index" class="tab">
          <div v-for="b in data.Benefits" :key="b">
            <img :src=requireImage(b.src) alt="">
            <span>{{b.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <van-cell-group>
      <van-cell title="充值记录" is-link to="index" icon="orders-o"/>
    </van-cell-group>

  </div>
  <div class="fixedFooter">
    <div @click="$router.push('/user/pay')">
      <van-icon name="guide-o" size="4.8vw"/>
      <p>GO充值</p>
    </div>
    <van-button type="primary" round color="#fb7a9f" @click="upgrade">确认购买 {{cost}}CNY</van-button>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import NavTop from "@/components/common/NavTop";
import { Autoplay, Navigation, Pagination, A11y } from 'swiper'
import 'swiper/css'
import {showFailToast, showLoadingToast} from "vant";
import {handleError} from "@/utils/ecode";
import data from "@/assets/json/data.json"
import {getUserInfo} from "@/utils/http";

export default {
  name: "userPay",
  components:{
    NavTop,
    Swiper,
    SwiperSlide,
  },
  data(){
    const defaultIndex = 0
    return {
      user:this.$store.getters.getUser,
      model:{},
      modules:[Autoplay, Pagination, Navigation, A11y],
      tabsIndex: defaultIndex,
      upgradeData:data.upgrade,
      updateVipType:data.upgrade[defaultIndex].type,
      cost:data.upgrade[defaultIndex].cny
    }
  },
  computed:{
    truncatedUserId() {
      const maxLength = 10; // 设置最大长度
      if (this.user.card.userid.length > maxLength) {
        return this.user.card.userid.substring(0, maxLength) + '***';
      } else {
        return this.user.card.userid;
      }
    },
    balance(){
      return this.user.balance.remaining.toFixed(2)
    },
  },
  methods:{
    onchange(swiper){
      this.tabsIndex = swiper.realIndex;
      console.log(this.tabsIndex)
    },
    async upgrade(){
      showLoadingToast({
        message: 'SVIP升级中...',
        forbidClick: true,
      });
      try {
        const res = await this.$user_http.post(`/user/svipUpgrade?vip_type=${this.updateVipType}`);
        if (res.data.code === 0) {
          const code = await getUserInfo()
          if (code ==0) {
            showLoadingToast({
              message: 'SVIP升级成功...',
              forbidClick: true,
            });
            let path = sessionStorage.getItem('redirectPath') || '/';
            sessionStorage.removeItem('redirectPath');
            this.$router.push(path);
            return;
          }
        } else {
          handleError(res.data.code, null);
        }
      } catch (error) {
        showFailToast("网络链接失败!请检查网络！或稍后再试");
        console.error('Error fetching data:', error);
      }
    },
    requireImage(src) {
      return require(`@/assets/${src}`)
    }
  },
  watch:{
    tabsIndex(i){
      this.cost = this.upgradeData[i].cny
      this.updateVipType = this.upgradeData[i].type
      console.log(this.updateVipType)
    }
  },

}
</script>

<style scoped lang="scss">
.user {
  margin: 3vw;
  background-color: #fb7a9f;
  border-radius: 2vw;
  height: 25vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .userInfo{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3.8vw;
    margin-left: 3vw;
    div:nth-child(2){
      display: flex;
      flex-direction: column;
      gap: .68vw;
      color: white;
    }
    img{
      width: 44px;
      border-radius: 50%;
    }

  }
  .vipSign{
    display: flex;
    text-align: center;
    margin-right: 3vw;
    img{
      width: 50px;
    }
  }
}
.container {
  height: 100%;
  background-color: white;
  .package_title{
    font-size: 4.0vw;
  }
  .package_trc{
    margin-top: 1.5vw;
    font-size: 3.2vw;
  }
  .package_originalPrice {
    margin-top: 1.5vw;
    font-size: 2.8vw;
    opacity: .68;
  }
  .package_price{
    margin-top: 1.5vw;
  }
  .vipSwiper {
    height: 35vw;
    color: rgb(56, 46, 0);
    font-family: PingFangSC-Medium;
    line-height: 1.05131rem;
    margin-left: 3vw;
    .swiperPackage{
      display: flex;
      background-size: cover; /* 使背景图覆盖整个容器 */
      background-position: center; /* 背景图居中 */
      height: 35vw;
      max-height: 35vw;
      border-radius: 2vw;
      div:nth-child(1){
        flex: 1;
      }
    }
    .swiperFirst {
      background-image: url('@/assets/month_7_days_bg@2x.png');
    }
    .swiperSecond {
      background-image: url('@/assets/month_bg@2x.png');
    }
    .swiperThird {
      background-image: url('@/assets/oneyear_bg@2x.png');
    }
    .swiperForth {
      background-image: url('@/assets/super_bg@2x.png');
    }
    img{
      width: 15vw;
      margin-top: 2vw;
      margin-right: 2vw;
    }
  }
  .tabs {
    display: flex;
    flex-direction: column;
    .tab {
      display: none;
      img{
        width: 44px;
      }
    }
    .tabsTitle{
      font-size: 3.5vw;
      margin-top: 3vw;
      margin-left: 3vw;
    }
    .active-tab {
      display: flex;
      flex-wrap: wrap; /* 允许换行 */
      gap: 1vw; /* 设置元素间的间距 */
      margin: 2vw 0;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 24vw;
        font-size: 2.8vw;
      }
    }
  }
}
.fixedFooter {
  width: 100%;
  display: flex;
  position: fixed;
  justify-content: space-between;
  bottom:0vw;
  padding: 2vw;
  div:nth-child(1){
    margin-left: 3vw;
    justify-content: start;
    align-items: center;
    display: flex;
    flex: 1;
    gap: .68vw;
  }
  button{
    width: 60vw;
    margin-right: 3.5vw;
  }
}
</style>
